import { match } from 'ts-pattern'
import type {
  ModalTypes,
  SendLinkToCustomerModalProps,
  TwoButtonsProps
} from '../lib/ModalContext/types'
import { ModalTwoButtons } from './ModalTwoButtons'
import { QRCodeModal } from './QRCodeModal'
import { SendLinkToCustomerModal } from './SendLinkToCustomerModal'

type CustomModalProps = {
  readonly isOpen: boolean
  readonly modalType: ModalTypes
  readonly onRequestClose: () => void
  readonly twoButtonsProps?: TwoButtonsProps | null
  readonly sendLinkToCustomerProps?: SendLinkToCustomerModalProps | null
}

export function CustomModal({
  isOpen,
  modalType,
  onRequestClose,
  twoButtonsProps = null,
  sendLinkToCustomerProps = null
}: CustomModalProps) {
  return (
    match(modalType)
      .with('two-buttons', () =>
        twoButtonsProps ? (
          <ModalTwoButtons
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            {...twoButtonsProps}
          />
        ) : null
      )
      .with('send-link-to-customer', () =>
        sendLinkToCustomerProps ? (
          <SendLinkToCustomerModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            {...sendLinkToCustomerProps}
          />
        ) : null
      )
      // add more modal types here
      .with(
        'qr-code',
        () =>
          sendLinkToCustomerProps && (
            <QRCodeModal
              isOpen={isOpen}
              onRequestClose={onRequestClose}
              sendLinkToCustomerProps={{
                ...sendLinkToCustomerProps,
                isOpen,
                onRequestClose
              }}
            />
          )
      )
      .with(null, () => null) //no modals to render
      .exhaustive()
  )
}
